import { getSessionStorage, setSessionStorage, trackCustomEvent } from '@healthhub/react-ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { EVENT_NAMES } from '@shared/constants/eventTrackers';

import { useCurrentUserOrCurrentFederatedUser } from '../useCurrentUserOrCurrentFederatedUser';
import useIsAuthenticated from '../useIsAuthenticated';
import useRelatedPeople from '../useRelatedPeople';
import useUpdateLoginDate from '../useUpdateLoginDate';

const useGlobalLoading = () => {
  const [searchParams] = useSearchParams();

  const mid = searchParams.get('mid');
  const { isAuthenticated } = useIsAuthenticated();
  const { isLoading: isUpdateLoginDateLoading } = useUpdateLoginDate();
  const { userProfile, isLoading: isLoadingUserProfile } = useCurrentUserOrCurrentFederatedUser({
    isPatientMasterInfoRequired: false,
    skip: isUpdateLoginDateLoading,
  });

  const { isLoading: isLoadingRelatedPeople } = useRelatedPeople({
    skip: !isAuthenticated || isUpdateLoginDateLoading,
  });

  useEffect(() => {
    if (userProfile?.Prn) {
      const userPrn = getSessionStorage(EVENT_NAMES.USER_PRN);
      if (userPrn) return;

      setSessionStorage(EVENT_NAMES.USER_PRN, userProfile.Prn);
      trackCustomEvent(EVENT_NAMES.USER_PRN, { prn: userProfile.Prn });
    }
  }, [userProfile]);

  // TODO: Jason handling the userProfile error
  return isAuthenticated && (isLoadingUserProfile || !userProfile || (!!mid && isLoadingRelatedPeople));
};

export default useGlobalLoading;
